import React, { useState, useContext } from 'react'
import { useDispatch } from 'react-redux'
import AddIcon from '@material-ui/icons/Add'
import CloseIcon from '@material-ui/icons/Close'
import { IconButton } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'

import Title from 'components/CommonUI/Title/Title'
import ButtonStyled from 'components/CommonUI/Button/Button'
import DropdownMenu from 'components/CommonUI/Dropdown'
import { hex } from 'utils/hex'
import {
  getPanelMeterTypesSelector,
  getIsFetchingMeterUpdateSelector,
} from 'redux/reducers/devices'
import { useShallowEqualSelector } from 'custom-hooks'
import { MeterContex } from './PanelEditModal'
import { openConfirmationModal } from 'redux/reducers/confirmationModal'

const _METERS_COLOR = ['#1772F5', '#0F9F03', '#E5911C']

const ModalMeterConfiguration = ({ meters = [] }) => {
  return (
    <div className="modal_meter_configuration_container">
      <Title
        title="Meters configuration"
        component="h3"
        className="modal_meter_configuration_title"
      />
      {_METERS_COLOR.map((color, item) => {
        return (
          <SlotMeterItem
            key={color}
            slot={item + 1}
            meterData={meters.find((m) => m.meter_id === item + 1)}
          />
        )
      })}
    </div>
  )
}

const SlotMeterItem = ({ meterData, slot }) => {
  const [isCreate, setIsCreate] = useState(false)

  const isFetchingMeterUpdate = useShallowEqualSelector(
    getIsFetchingMeterUpdateSelector
  )

  const handleClickCreate = () => {
    setIsCreate((pr) => !pr)
  }

  return (
    <div className="modal_meter_configuration_item_container">
      {meterData || isCreate ? (
        <AddedMeter
          meterData={meterData}
          isCreate={isCreate && !meterData}
          slot={slot}
          onClose={handleClickCreate}
          isFetchingMeterUpdate={isFetchingMeterUpdate}
        />
      ) : (
        <ButtonStyled
          className="modal_meter_configuration_button"
          startIcon={<AddIcon />}
          variant="outlined"
          onClick={handleClickCreate}
          disabled={isFetchingMeterUpdate}
        >
          Add meter {slot}
        </ButtonStyled>
      )}
    </div>
  )
}

const AddedMeter = ({
  meterData,
  isCreate,
  slot,
  onClose,
  isFetchingMeterUpdate,
}) => {
  const dispatch = useDispatch()
  const color = _METERS_COLOR[slot - 1]
  const paneslType = useShallowEqualSelector(getPanelMeterTypesSelector)

  const [selecterValue, setSelectedValue] = useState(() => {
    return paneslType.find((p) => p.id === meterData?.meter_type_id)
  })

  const handleSubmitMeter = useContext(MeterContex)

  const handleSelect = (selectedData) => {
    const title = (
      <span>
        <p style={{ marginBottom: '10px' }}>
          Do you confirm adding a meter with type{' '}
          <b>{selectedData.value.name}</b> to the panel in slot <b>{slot}</b>?
        </p>
        <span style={{ color: 'red' }}>Pay Attention!!! </span>After adding you
        cannot delete this meter from the panel or change the type of meter
      </span>
    )

    setSelectedValue(selectedData)
    dispatch(
      openConfirmationModal({
        modalData: {
          title: 'Meter adding',
          description: title,
          leftButtonTitle: 'Add meter',
        },
        cb: handleSubmitMeter,
        arg: {
          meter_type_id: selectedData?.value?.id,
          meter_id: slot,
        },
      })
    )
  }

  return (
    <div className="added_meter_container">
      <div className="meter_left_section">
        <span
          style={{
            backgroundColor: hex(color),
            color: color,
          }}
          className="meter_number"
        >
          {meterData?.meter_id || slot}
        </span>
        <div className="meter_name_sections">
          <span className="meter_name">
            Meter {meterData?.meter_id || slot}
          </span>
        </div>
      </div>
      <div className="meter_right_section">
        {selecterValue && meterData?.meter_type_id ? (
          <span className="meter_type_name">{selecterValue.label}</span>
        ) : (
          <DropdownMenu
            classNameContainer="meter_type_select"
            emptyValue="Choose type"
            selectedValue={selecterValue}
            disabled={!!(selecterValue && meterData?.meter_type_id)}
            handleSelectedClick={handleSelect}
          >
            {paneslType.map((pt) => (
              <DropdownMenu.Item key={pt.id} itemData={pt} />
            ))}
          </DropdownMenu>
        )}
        {isCreate &&
          (isFetchingMeterUpdate ? (
            <span className="meter_delete_button">
              <CircularProgress size={24} />
            </span>
          ) : (
            <IconButton className="meter_delete_button" onClick={onClose}>
              <CloseIcon className="meter_delete_button_icon" />
            </IconButton>
          ))}
      </div>
    </div>
  )
}

export default ModalMeterConfiguration
